<template>
  <Toast :close-tip="true" :close-event="closeEvent">
    <div class="top-title">友情提醒</div>
    <p class="info err-info">活动太火爆了，请稍后再试</p>
    <p class="btn" @click="close">进店逛逛</p>
  </Toast>
</template>

<script>
import Toast from "./../VueToast"
export default {
  name: 'CommonErr',
  props: {
    closeEvent: Function,
    event: Function
  },
  components: {
    Toast
  },
  methods: {
    close () {
      this.closeEvent();
      this.event();
    }
  }

}
</script>

<style lang="scss" scoped>
.info {
  margin: 35px 0 54px;
  font-size: 12px;
  color: #666666;
  letter-spacing: 0;
  text-align: center;
  line-height: 17px;
}
.top-title {
  margin: -5px auto 0;
  width: 144px;
  height: 38px;
  font-weight: 500;
  font-size: 14px;
  color: #FFFFFF;
  letter-spacing: 0;
  text-align: center;
  line-height: 32px;
  background-image: url("./../../../assets/img/toast-red-title@2x.png");
  background: -webkit-image-set(
    url("./../../../assets/img/toast-red-title.png") 1x,
    url("./../../../assets/img/toast-red-title@2x.png") 2x,
    url("./../../../assets/img/toast-red-title@3x.png") 3x
  );
  background-size: 100%;
  background-repeat: no-repeat;
}
.btn {
  margin: 0 auto;
  width: 120px;
  height: 32px;
  line-height: 32px;
  font-weight: 500;
  font-size: 12px;
  color: #FFF8EF;
  text-align: center;
  background-image: linear-gradient(0deg, #FF2B19 0%, #FF7664 100%);
  border-radius: 100px;
}
</style>